import { createContext, useContext } from "react";
const ExperimentsContext = createContext(
  void 0
);
const useExperiments = () => {
  const experiments = useContext(ExperimentsContext) || {};
  return {
    experiments,
    isExperimentEnabled: (spec) => experiments[spec] === true || experiments[spec] === "true" || false
  };
};
export {
  ExperimentsContext,
  useExperiments
};
//# sourceMappingURL=experiments-context.js.map
